import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import OptionList, { Option } from '../';

/** @visibleName Single Select List */
export class SingleSelectList extends PureComponent {
  static propTypes = {
    /** all component children nodes */
    children: PropTypes.node,
    /** selected option value */
    selectedOption: PropTypes.any,
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedOption: props.selectedOption,
      currentFocusIndex: -1,
    };

    this.handleOptionSelected = this.handleOptionSelected.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleOptionSelected(option) {
    this.setState({
      selectedOption: option.props.item,
    });

    option.props.onSelect && option.props.onSelect(option.props.item);
  }

  handleKeyDown(currentFocusIndex) {
    this.setState({
      currentFocusIndex,
    });
  }

  render() {
    return (
      <OptionList
        {...this.props}
        onKeyDown={this.handleKeyDown}
        currentFocusIndex={this.state.currentFocusIndex}
      >
        {React.Children.map(this.props.children, (option, index) => {
          return (
            <Option
              {...option.props}
              autoFocus={index === this.state.currentFocusIndex}
              onSelect={_.partial(this.handleOptionSelected, option)}
              isSelected={
                option.props.isSelected ||
                _.isEqual(this.state.selectedOption, option.props.item)
              }
            />
          );
        })}
      </OptionList>
    );
  }
}

export default SingleSelectList;
